import { parseMarginPadding, parseResult } from '../controlUtils';

export function displayRuleUtil(obj, entryPoint){

    const content = JSON.parse(obj.Content);
    const display = content.Display;
    const direction = content.Direction;
    const theme = content.Theme;
    const size = content.Size;
    const label = content.Label;
    const marginPadding = content.MarginPadding;

    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let length = 0;
    if(display == "default"){ length = 60 }
    else if(display == "medium"){ length = 180 }
    else if(display == "long"){ length = (direction=="horizontal")? '100%': 260 }

    let sz = 0;  let lbSz = 0; let zoom = 0;
    if(size == "small"){sz=1; lbSz = 12}
    else if(size == "medium"){ sz=3; lbSz = 13}
    else if(size == "large"){ sz=6; lbSz = 14}
    else if(size == "xlarge"){ sz=10; lbSz = 16}
    else if(size == "xxlarge"){ sz=16; lbSz = 18}

    if(entryPoint == "presentation" && obj.Presentation != ""){
        const ptn = JSON.parse(obj.Presentation);
        if(ptn.TitleSize != "") { lbSz = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { sz = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { sizeParams.zoom = parseInt(ptn.Zoom) }
    }

    const styles = {
        wrap:{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zoom: `${zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        },
        body:{
            flex: 1,
        },
        wrapRule:{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        horizontalRule:{
            background: (bgColor == "#fff")? '#ccc': bgColor,
            width: length,
            height: sz,
            borderRadius: 3
        },
        verticalRule:{
            background: (bgColor == "#fff")? '#ccc': bgColor,
            width: sz,
            height: length,
            borderRadius: 3
        },
        label:{
            color: (bgColor == "#fff")? '#ccc': bgColor,
            marginBottom: 10,
            fontSize: lbSz,
            textAlign: 'center'
        },
    }

    const elem = (
        <div style={styles.wrap}>
            <div style = {styles.body}>
                {(direction != "vertical") && <div style={styles.label}>{label}</div>}
                <div style={styles.wrapRule}>
                    {(direction == "horizontal") && <div style={styles.horizontalRule}></div>}
                    {(direction == "vertical") && <div style={styles.verticalRule}></div>}
                </div>
            </div>
        </div>
    )

    return parseResult(elem, obj, entryPoint);

}